/**
 * @generated SignedSource<<ffa60ed574f3d1189e97a9eaa3b8c340>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommentSummaryCell$data = {
  readonly commentSummary: {
    readonly canAddComment: boolean | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CommentSummaryCell";
};
export type CommentSummaryCell$key = {
  readonly " $data"?: CommentSummaryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentSummaryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentSummaryCell",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
};

(node as any).hash = "4704a2d7c0c9a0c38b8dab59696c6807";

export default node;
